import { Injectable } from '@angular/core';
import {Platform} from '@ionic/angular';
import { ToastController,AlertController,LoadingController } from '@ionic/angular';
import {ResponseMessage} from '../model/common';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Device } from '@ionic-native/device/ngx';
@Injectable({
  providedIn: 'root'
})
export class MessageclientService {

   _loading:any;
  constructor(
    private toastController:ToastController,
    public alertController: AlertController,
    public loadingController: LoadingController,
    private platform:Platform,
    private appversion:AppVersion,
    private device:Device
    ) {
      
     }
/**
 * 弹出消息框
 * @param _message 提示内容
 * @param _title 标题
 * @param _btnName 确定按钮文字 默认”确定“
 * @param isClose 是否硬件返回时关闭,默认关闭 true
 */
// public async Alert(_message:string,_title:string="系统提示",_btnName:string="确定",isClose:boolean = true):Promise<any>{
  public async Alert(_message:string,_title:string="系统提示",_btnName:string="确定",isClose:boolean = true,msgCssClass:any = ""):Promise<any>{
  const that=this;
  try{
      const alert = await that.alertController.getTop();
      if(alert){
        alert.dismiss();
      }
  }catch(err){

  }
  return await new Promise<any>((resolve,reject)=>{
    localStorage.removeItem("ISCLOSE");
    if(!isClose){localStorage.setItem("ISCLOSE",JSON.stringify({"isclose":true}));}else{localStorage.removeItem("ISCLOSE");}
   let isplatform:boolean =false;//标识是否版本低于4.0
   if(that.platform.is("cordova")){
    if(that.platform.is("android")){
      if(that.device.version){
        if(that.device.version.toString().startsWith("4")){
          isplatform=true;
        }else if(that.device.version.toString().startsWith("3")){
          isplatform=true;
        }else if(that.device.version.toString().startsWith("2")){
          isplatform=true;
        }
      }
     }
   }
   if(isplatform){
    if(_message){
      _message = _message.replace(/<br\s*\/?>/gi,"\r\n");
      _message = _message.replace(/<\/?.+?\/?>/g,"");
    }
    window.alert(_message);
    resolve(true);
   }else{
    that.alertController.create({
      header: _title,
      // subHeader: '系统提示框',
      message: _message,
      mode:"ios",
      backdropDismiss:false,
      buttons: [{
        text: _btnName, handler: data => {
          localStorage.removeItem("ISCLOSE");
          resolve(true);
        }
      }]
    }).then(element=>{
      element.present();
    }).catch((error)=>{
      localStorage.removeItem("ISCLOSE");
      reject(error);
    });
   }
  });
  }
  async BackAlert(_message:string,btnName:any="确定",_title:string="系统提示",input:Array<any>=[]):Promise<any>{
    const that=this;
    return await new Promise<any>((resolve,reject)=>{
      that.alertController.create({
        header: _title,
        // subHeader: '系统提示框',
        message: _message,
        backdropDismiss:false,
        inputs:input,
        mode:"ios",
        buttons: [{
          text: btnName, handler: data => {
            resolve("ok");
          }
        }]
      }).then(element=>{
        resolve(element.message);
        element.present();
      }).catch((error)=>{
        reject(error);
      })
    });
    }
    /**
     * 弹出可确定按钮
     * @param _message 提示内容消息展示
     * @param callBack 确定/取消按钮方法,返回"false":表示取消,"true":表示确定
     * @param msgCssClass 样式类名称
     * @param isClose 是否硬件返回时关闭,默认关闭 true
     */
    async Confirm(_message:string,cancelmessage:string="取消",okayMessage:string="确定",msgCssClass:string='',isClose:boolean = true):Promise<any>{
      const that=this;
      return await new Promise<any>((resolve,reject)=>{
        let isplatform:boolean =false;//标识是否版本低于4.0
        if(that.platform.is("cordova")){
        if(that.platform.is("android")){
          if(that.device.version){
            if(that.device.version.toString().startsWith("4")){
              isplatform=true;
            }else if(that.device.version.toString().startsWith("3")){
              isplatform=true;
            }else if(that.device.version.toString().startsWith("2")){
              isplatform=true;
            }
          }
         }
        }
         if(isplatform){
          if(_message){
            _message = _message.replace(/<br\s*\/?>/gi,"\r\n");
            _message = _message.replace(/<\/?.+?\/?>/g,"");
          }
          if(window.confirm(_message)){
            resolve(true);
           }else{
            resolve(false);
           }
         }else{
          that.alertController.create({
            header: '系统提示',
            message: _message,
            mode:"ios",
            cssClass:msgCssClass,
            backdropDismiss:false,
            buttons: [
              {
                text: okayMessage,
                cssClass:'btn-okay',
                handler: (Okay) => {
                  resolve(true);
                }
              },
              {
                text: cancelmessage,
                role: 'cancel',
                cssClass: 'secondary btn-cancel',
                handler: (cancel) => {
                  resolve(false);
                }
              }
            ]
          }).then(data=>{
            data.present();
           
          }).catch(error=>{
            reject(error);
          });
         }
      });
    }
   /**
    * 
    * @param _message 提示消息
    * @param _postion 展示位置,bottom,选择值为："top", "middle", "bottom".
    * @param isAutoClose 是否手动关闭提示框，默认自动关闭，默认关闭时间为3秒，及3000.
    * @param duration 自动关闭时间,默认为3000毫秒.
    */
    async Show(_message:string,_postion:string="bottom",isAutoClose:boolean=false,duration:number=1500) {
      let option:any={
        message: _message,
        position: _postion,
        color:"dark"
      };
      //判断是否手动关闭
      // if(isAutoClose){
      //   option["showCloseButton"]=true;
      //   option["closeButtonText"]="关闭";
      // }else{
      //   option["duration"]=duration;
      // }
      option["duration"]=duration;
      const toast = await this.toastController.create(option);
      toast.present();
    }
/**
 * 加载提示框
 * @param _message 提示内容,可以为空
 * @param _id dom对象ID属性,默认为null
 * @param _spinner 提示框图标名称 默认为 “circles”
 */
    async Loading(_message?:string,_id:string=null,_spinner:string="circles"){
     
      let option:any={spinner:_spinner};
      if(_id){option["id"]=_id;};
      if(_message){option["message"]=_message;};
      return await this.loadingController.create(option);
    //   this.loading = await this.loadingController.create(option);
    //  return this.loading.present();
    }
    /**
     * 根据ID关闭Loading加载项
     * @param id loading页面唯一属性
     */
    LoadingDismiss(id:string){
      this.loadingController.dismiss("","",id);
      if(this.platform.is("cordova")){
        document.getElementById(id).remove();
      }
     //
    }
    /**
     * 提示错误信息
     * @param error 错误信息展示
     */
    ErrorMessage(error:any):Promise<ResponseMessage>{
      return new Promise<ResponseMessage>(function(resolve,reason){
        let responseMessage:ResponseMessage=new ResponseMessage();
            responseMessage.ErrorCode=0;
            responseMessage.Success=false;
            responseMessage.ErrorMessage=error;
           reason(responseMessage);
      });
    }
    
}